import { render } from "./ContractsDashboardV2.vue?vue&type=template&id=373eae57&scoped=true"
import script from "./ContractsDashboardV2.vue?vue&type=script&lang=js"
export * from "./ContractsDashboardV2.vue?vue&type=script&lang=js"

import "./ContractsDashboardV2.vue?vue&type=style&index=0&id=373eae57&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373eae57"]])

export default __exports__